<div class="row">
    <div class="col">
            <img style=" width:100%; object-fit: 100% 100%;" 
                                src="../../../../../../assets/img/header-promotion2.jpg" alt="">
        <!-- <div class="ps-block--promotion-header bg--cover"  [ngStyle]="{'background-image': promo}">
            <div class="container">
                <div class="ps-block__left">
                    <figure>
                        <h4 style="opacity: 0;"></h4>
                    </figure>
                </div>
              </div>
          </div> -->
    </div>
</div>

